export const DEFAULT_OFFER = '00000000-0000-0000-0000-000000000000';
